<template>
  <span
    class="match-result match-result-server-sport flex font-bold"
    :class="{ 'match-tennis': isTennis }">
    <span
      class="period-points color-important text-center"
      :class="{ 'match-tennis': isTennis }">
      {{ gameScore }}
    </span>
    <span
      class="period color-faded text-center"
      :class="{ 'color-normal': index === 0 && isTennis,
                'color-important': index === 0 && !isTennis }"
      v-for="(period, index) in resultPeriod"
      :key="index">
      <span
        :class="{ 'color-normal': isHigher(period[0], period[1]) && isTennis ||
          isHigher(period[0], period[1]) && !isTennis && index !== 0
        }">
        {{ period[0] }}
      </span>
      <span>:</span>
      <span
        :class="{ 'color-normal': isHigher(period[1], period[0]) && isTennis ||
          isHigher(period[1], period[0]) && !isTennis && index !== 0
        }">
        {{ period[1] }}
      </span>
    </span>
  </span>
</template>

<script>
import { comparison, sport } from '@/services/mixins';

export default {
  name: 'MatchResultsTennis',
  mixins: [
    comparison,
    sport,
  ],
  props: {
    gameScore: {
      required: true,
      type: String,
      default: '',
    },
    resultPeriod: {
      required: true,
      type: Array,
    },
    idSport: {
      required: true,
      type: Number,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.match-result-server-sport {
  position: relative;
  flex-direction: row-reverse;

  &.match-tennis {
    padding-right: $match-points-width;
  }
}

.period {
  position: relative;
  width: 5vw;
}

.period-points {
  position: absolute;
  top: 0;
  left : -$match-points-width;
  bottom: 0;
  width: $match-points-width;

  &.match-tennis {
    right: 0;
    left: unset;
  }
}
</style>
